// extracted by mini-css-extract-plugin
export default {"items":"items-b882","item":"item-12e9"};